

<template>

<div>
    <v-row align="center" justify="center">
        <v-col cols="1"></v-col>
        <v-col>
            <v-card elevation="2" style="width:800px; min-height:670px">
                <v-card-title>Key Information</v-card-title>
                <v-divider class="mx-4 ma-1" style="margin-top:-1% !important"></v-divider>
                <v-form ref="data" class="ma-4">
                    <v-row style="height:65px">
                        <v-col cols="4">
                            <v-text-field v-model="key.oem" :rules="[rules.required]" dense type="text" required label="OEM:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="key.fcc" :rules="[rules.required]" dense type="text" required label="FCC:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="key.ic" :rules="[rules.required]" dense type="text" required label="IC:" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row style="height:65px">
                        <v-col cols="4">
                            <v-text-field dense v-model="key.globalpart" type="text" required label="Global Part:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense v-model="key.isku" type="text" required label="Internal Sku:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense v-model="key.freq" type="text" required label="Frequency:" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row style="height:65px">
                        <v-col cols="4">
                            <v-text-field dense v-model="key.threshold" :rules="[rules.required]" type="number" required label="Threshold:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="key.keyType.type" :rules="[rules.required]" dense outlined label="Key Type" :items="keyTypes" :item-value="item => item.type" :item-text="item => item.type"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="key.transponder.transponder" dense outlined label="Transponder:" :items="transponders" :item-value="item => item.transponder" :item-text="item => item.transponder"></v-select>
                        </v-col>
                    </v-row>
                    <v-row style="height:65px">
                        <v-col cols="4">
                            <v-text-field dense v-model="key.description" type="text" required label="Description:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense v-model="key.notes" type="text" required label="Notes:" outlined></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4">
                            <v-file-input @change="selectFile" show-size lable="Image Input" accept="image/*" dense></v-file-input>
                        </v-col>
                        <v-col cols="4">
                            <h6>Buttons:</h6>
                            <b-button v-for="button in buttons" :key="button.key" size='sm' class="badge" :variant="check(button.button)" @click="badge(button.button)" style="margin-left:2px">
                                {{button.button}}
                            </b-button>
                        </v-col>
                    </v-row>

                </v-form>
                <v-divider></v-divider>

                <v-card-title style="height:50px;margin-top:-3% !important">Suppliers:</v-card-title>
                <v-row v-if="key.supAssociation.length > 0">
                    <v-col cols="2">

                    </v-col>
                    <v-col cols="10">
                        <v-chip color="primary" @click:close="removeSupplier(sup)" outlined close style="margin-left:2px; margin-top:2px" v-for="sup in key.supAssociation">
                            {{sup.supplier.name}} - {{sup.sup_sku}}
                        </v-chip>
                    </v-col>
                </v-row>
                <v-form ref="supplier" lazy-validation>
                    <v-row style="height:65px">
                        <v-col cols="2">
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="supplier.supplier" dense :rules="[rules.required]" outlined label="Supplier" :items="suppliers" :item-value="item => item" :item-text="item => item.name"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense v-model="supplier.sup_sku" :rules="[rules.required]" type="text" label="SKU:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn color="info" @click="addSupplier">
                                ADD
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-divider></v-divider>
                <v-card-title style="height:50px;margin-top:-3% !important">Manufacturers:</v-card-title>
                <v-row v-if="key.manAssociation.length > 0">
                    <v-col cols="2">

                    </v-col>
                    <v-col cols="10">
                        <v-chip color="primary" @click:close="removeManufacturer(man)" outlined close style="margin-left:2px; margin-top:2px" v-for="man in key.manAssociation">
                            {{man.manufacturer.name}} - {{man.man_sku}}
                        </v-chip>
                    </v-col>
                </v-row>
                <v-form ref="manufacturer" lazy-validation>
                    <v-row style="height:65px">
                        <v-col cols="2">
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="manufacturer.manufacturer" dense :rules="[rules.required]" outlined label="Manufacturer" :items="manufacturers" :item-value="item => item" :item-text="item => item.name"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense v-model="manufacturer.man_sku" :rules="[rules.required]" type="text" label="SKU:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn color="info" @click="addManufacturer">
                                ADD
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-divider></v-divider>
                <v-card-title style="height:50px;margin-top:-3% !important">Compatible Vehicles:</v-card-title>

                <v-row v-if="key.compatibleVeh.length > 0">
                    <v-col cols="1">

                    </v-col>
                    <v-col cols="10">
                        <v-chip color="primary" @click:close="removeVeh(veh)" outlined close column style="margin-left:2px; margin-top:2px" v-for="veh in key.compatibleVeh">
                            {{veh.key.make}} - {{veh.key.model}} - {{veh.key.year}}
                        </v-chip>
                    </v-col>
                </v-row>

                <v-form ref="veh" lazy-validation>
                    <v-row>
                        <v-col cols="1"></v-col>
                        <v-col>
                            <v-autocomplete cols="2" @focus="onFocus()" v-model="make" :rules="[rules.required]" :items="makes" dense chips clearable @click:clear="reset()" @change="makeChange" item-color='blue' small-chips label="Make" solo></v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-autocomplete cols="2" v-model="model" :items="models" :rules="[rules.required]" dense chips @change="modelChange" small-chips label="Model" solo></v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-autocomplete cols="2" v-model="year" :items="years" :rules="[rules.required]" dense chips small-chips label="Year" solo></v-autocomplete>
                        </v-col>
                        <v-col cols="2">
                            <v-btn color="info" @click="addVehicle()">
                                ADD
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-row align="center" specify="center" style="min-height:60px">
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        <v-btn color="success" @click="save">
                            Save
                        </v-btn>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <v-btn color="error" @click="cancel">
                            Cancel
                        </v-btn>
                    </v-col>

                </v-row>

            </v-card>
        </v-col>
    </v-row>

</div>

</template>

<script>

export default {
    created() {
            this.$overlay.show(this);

            this.$api.getKeyTypes().then((response) => {
                if (response.status == 200) {
                    this.keyTypes = response.data;
                }
            }).catch(error => {

            });

            this.$api.getTransponders().then((response) => {
                if (response.status == 200) {
                    this.transponders = response.data;
                }

            }).catch(error => {

            });

            this.$api.getManufacturers().then((response) => {
                if (response.status == 200) {
                    this.manufacturers = response.data;
                }
            });

            this.$api.getSuppliers().then((response) => {
                if (response.status == 200) {
                    this.suppliers = response.data;
                }
            })

            this.$api.getButtons().then((response) => {
                if (response.status == 200) {
                    this.buttons = response.data;
                }
                this.$overlay.hide();
            }).catch(error => {
                this.$overlay.hide();
            })
        },
        name: "",
        data: () => ({
            key: {
                globalpart: '',
                description: '',
                oem: '',
                fcc: '',
                ic: '',
                notes: '',
                image: '',
                isku: '',
                freq: '',
                threshold: '',
                keyType: {
                    type: ''
                },
                transponder: {
                    transponder: ''
                },
                buttons: [

                ],
                supAssociation: [

                ],
                manAssociation: [

                ],
                compatibleVeh: []
            },
            keyTypes: [],
            transponders: [],
            manufacturers: [],
            manufacturer: {
                manufacturer: null,
                man_sku: ''
            },
            suppliers: [],
            supplier: {
                supplier: null,
                sup_sku: '',
            },
            buttons: [],
            makes: [],
            make: '',
            file: '',
            models: [],
            model: '',
            years: [],
            year: '',
            rules: {
                required: value => !!value || 'Required.'
            }
        }),
        methods: {
                selectFile(file) {
                    this.file = file;
                },
                save() {
                    if (this.$refs.data.validate()) {
                        this.$overlay.show(this);
                        this.$api.saveKey(this.key,this.file).then((response) => {
                            if (response.status == 202) {
                                this.$toasted.success("Key Added").goAway(1000);
                                this.cancel();
                            }
                            this.$overlay.hide();
                        }).catch(error => {
                            this.$overlay.hide();
                        });
                    }
                },
                format(value) {
                    return value.toUpperCase()
                },
                check(button) {
                    var s = "secondary"
                    for (var i = 0; i < this.key.buttons.length; i++) {
                        if (this.key.buttons[i].button.localeCompare(button) == 0) {
                            s = "success"
                        }
                    }
                    return s;
                },
                badge(button) {
                    let x = this.exists(button);
                    if (x >= 0) {
                        this.key.buttons.splice(x, 1);
                    } else {
                        this.key.buttons.push({
                            'button': button
                        });
                    }
                },
                exists(button) {
                    var s = -1;
                    for (var i = 0; i < this.key.buttons.length; i++) {
                        if (this.key.buttons[i].button.localeCompare(button) == 0) {
                            s = i
                            break;
                        }
                    }
                    return s;
                },
                addSupplier() {
                    if (this.$refs.supplier.validate()) {
                        let x = this.findIndex(this.key.supAssociation, this.supplier.supplier.name);
                        if (x >= 0) {
                            this.$toasted.error("Already Exists").goAway(800);
                        } else {
                            this.key.supAssociation.push(this.supplier);
                            this.supplier = {
                                supplier: {
                                    name: ''
                                },
                                sup_sku: ''
                            }
                            this.$refs.supplier.reset();
                        }
                    }
                },
                removeSupplier(supplier) {
                    let x = this.findIndex(this.key.supAssociation, supplier.supplier.name);
                    this.key.supAssociation.splice(x, 1);
                },
                findIndex(suppliers, name) {
                    var s = -1;
                    for (var i = 0; i < suppliers.length; i++) {
                        if (suppliers[i].supplier.name.localeCompare(name) == 0) {
                            s = i
                            break;
                        }
                    }
                    return s;
                },
                findMIndex(suppliers, name) {
                    (name);
                    var s = -1;
                    for (var i = 0; i < suppliers.length; i++) {
                        if (suppliers[i].manufacturer.name.localeCompare(name) == 0) {
                            s = i
                            break;
                        }
                    }
                    return s;
                },
                addManufacturer() {
                    if (this.$refs.manufacturer.validate()) {
                        let x = this.findMIndex(this.key.manAssociation, this.manufacturer.manufacturer.name);
                        if (x >= 0) {
                            this.$toasted.error("Already Exists").goAway(800);
                        } else {
                            this.key.manAssociation.push(this.manufacturer);
                            this.manufacturer = {
                                manufacturer: {
                                    name: ''
                                },
                                man_sku: ''
                            }
                            this.$refs.manufacturer.reset();
                        }
                    }
                },
                removeManufacturer(manufacturer) {
                    let x = this.findIndex(this.key.manAssociation, manufacturer.manufacturer.name);
                    this.key.manAssociation.splice(x, 1);
                },
                makeChange() {
                    this.model = '';
                    this.year = '';
                    if (this.make != null) {
                        this.$api.getModels(this.make).then((response) => {
                            if (response.status == 200) {
                                this.models = response.data;
                            }
                        })
                    }
                },
                modelChange() {
                    this.year = '';
                    if (this.make != null && this.model != null) {
                        this.$api.getYears(this.make, this.model).then((response) => {
                            if (response.status == 200) {
                                this.years = response.data;
                            }
                        })
                    }
                },
                addVehicle() {
                    if (this.$refs.veh.validate()) {
                        let vehicle = {
                            key: {
                                make: this.make,
                                model: this.model,
                                year: this.year
                            }
                        };
                        let x = this.vehicleExists(this.key.compatibleVeh, vehicle)
                        if (x >= 0) {
                            this.$toasted.error("Already added").goAway(1000);
                        } else {
                            if (this.year != '') {
                                this.key.compatibleVeh.push(vehicle);
                                this.$toasted.success("Added").goAway(600);
                            }
                        }
                    }
                },
                removeVeh(veh) {
                    let x = this.vehicleExists(this.key.compatibleVeh, veh)
                    this.key.compatibleVeh.splice(x, 1);
                },
                vehicleExists(vehicles, vehicle) {
                    (vehicle.make);
                    (vehicles[0]);
                    let x = -1;
                    for (let i = 0; i < vehicles.length; i++) {
                        if (vehicles[i].key.make.localeCompare(vehicle.key.make) == 0 &&
                            vehicles[i].key.model.localeCompare(vehicle.key.model) == 0 &&
                            vehicles[i].key.year.localeCompare(vehicle.key.year) == 0) {
                            x = i;
                            break;
                        }
                    }
                    return x;
                },
                onFocus() {
                    this.$api.getMakes().then((response) => {
                        if (response.status == 200) {
                            this.makes = response.data;
                        }
                    }).catch(error => {})
                },
                cancel() {
                    this.$router.go(-1);
                },
                reset() {
                    this.$refs.veh.reset();
                }
        }
}

</script>
